module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gjCmlN/images/e9781439629819_cover.jpg?1684305842176",
      "alt": "This image is the cover for the book Northern Kentucky, Black America Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Northern Kentucky, Black America Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Along the picturesque southern banks of the Ohio River, the African-American communities of Boone, Campbell, and Kenton Counties have provided laborers and entrepreneurs to aid in the economic growth of the region from the earliest settlements to today. Despite numerous obstacles and against seemingly insurmountable odds, African Americans in Northern Kentucky made significant contributions in many fields, ranging from music, medicine, and literature to performing arts, poetry, education, and athletics.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Eric R. Jackson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dr. Eric R. Jackson, a resident of Florence, Kentucky, and an assistant professor of history at Northern Kentucky University, has compiled vintage images from archives, libraries, and personal collections to illustrate the spirit of numerous people, places, and events in Northern Kentucky�s African-American heritage.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0